import { motion } from "framer-motion";

const LOG_IMG =
  "https://images.pexels.com/photos/4487383/pexels-photo-4487383.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const stats = [
  { n: "18,400", unit: "tonnes", label: "CO₂e avoided through reuse & recycling" },
  { n: "98.6", unit: "%", label: "Material diverted from landfill" },
  { n: "$42M", unit: "recovered", label: "Value returned to clients via remarketing" },
];

export default function Impact() {
  return (
    <section id="impact" className="bg-secondary text-white py-20 md:py-32 relative overflow-hidden" data-testid="impact-section">
      <div className="mx-auto max-w-[1500px] px-5 md:px-10 relative z-10">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-6">
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-primary mb-4">/ Environmental impact</p>
            <h2 className="font-display font-extrabold uppercase tracking-tighter text-4xl md:text-6xl leading-[0.9] mb-10">
              Sustainability you can put in a report.
            </h2>
            <div className="space-y-0">
              {stats.map((s, i) => (
                <motion.div
                  key={s.label}
                  initial={{ opacity: 0, x: -30 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: i * 0.1 }}
                  className="flex items-baseline gap-4 py-6 border-t border-white/20"
                >
                  <div className="font-display font-black text-5xl md:text-6xl tracking-tighter text-primary">
                    {s.n}
                    <span className="text-white/50 text-xl font-mono ml-2">{s.unit}</span>
                  </div>
                  <p className="font-sans text-white/70 text-sm max-w-xs">{s.label}</p>
                </motion.div>
              ))}
            </div>
          </div>

          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="lg:col-span-6 h-[50vh] lg:h-[65vh] overflow-hidden border border-white/15 relative"
          >
            <img src={LOG_IMG} alt="Secure warehouse logistics" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-secondary/30 mix-blend-multiply" />
            <div className="absolute top-0 left-0 bg-white text-black px-3 py-1.5 font-mono text-[10px] uppercase tracking-widest">
              Secure Logistics / DXB
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
